/// <amd-module name="WidgetCommon/WitUtils/TempQueryUtils" />
import { newGuid } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { TemporaryDataCreatedDTO, TemporaryDataDTO } from "WidgetCommon/WitUtils/TemporaryDataClient/Contracts/TemporaryData";
import { ITemporaryQueryData } from "WidgetCommon/WitUtils/TemporaryDataClient/Contracts/TemporaryDataModel";
import { getTemporaryDataClient } from "WidgetCommon/WitUtils/TemporaryDataClient/RestClient/TemporaryData";

/*
 * This utiliy was copied from vss-work-web/work-items-hub
 */
export namespace TempQueryUtils {
    /**
     * Creates a temp query with the given WIQL and returns a promise with temp query id.
     * @param pageContext Page context
     * @param queryText WIQL query
     * @param queryType Optional query type description.
     * @returns A promise containing the query ID
     */
    export function beginCreateTemporaryQueryId(pageContext: IVssPageContext, queryText: string, queryType?: string): Promise<string> {
        const temporaryRestClient = getTemporaryDataClient(pageContext);
        const idGuid: string = newGuid();

        const temporaryQueryData = { queryText: queryText, queryType: queryType } as ITemporaryQueryData;
        return temporaryRestClient
            .createTemporaryData({ value: temporaryQueryData } as TemporaryDataDTO, idGuid)
            .then((response: TemporaryDataCreatedDTO) => response.id);
    }
}
